export const HEADER_MESSAGE_TYPES = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO'
};

export const HEADER_MESSAGE_IDS = {
  PORTFOLIO_NEEDS_FUNDS: 'PORTFOLIO_NEEDS_FUNDS'
};

// Shown (sticky) when a colleague takes over the company's single session slot
// and this user is force-logged-out (TD-2239). Used by both the WebSocket
// displaced push (immediate) and the focus/route re-check fallback.
export const SESSION_DISPLACED_MESSAGE =
  'You were signed out because a colleague took over your session.';
